import { render, staticRenderFns } from "./postEdit.vue?vue&type=template&id=cb3f5dc8&scoped=true&"
import script from "./postEdit.vue?vue&type=script&lang=js&"
export * from "./postEdit.vue?vue&type=script&lang=js&"
import style0 from "./postEdit.vue?vue&type=style&index=0&id=cb3f5dc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3f5dc8",
  null
  
)

export default component.exports